import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { EconomicGroupService } from "../../service/economic-group.service";
import { DialogService } from "ng2-bootstrap-modal";
import { EconomicGroupCreateComponent } from "../economic-group-create/economic-group-create.component";
import { FlashMessagesService } from "angular2-flash-messages/module";
import { EconomicGroupInsertUserComponent } from "../economic-group-insert-user/economic-group-insert-user.component";
import { Subscription } from "rxjs/Rx";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-economic-group',
	templateUrl: './economic-group.component.html',
	styleUrls: ['./economic-group.component.scss'],
	providers: [EconomicGroupService]
})
export class EconomicGroupComponent implements OnInit, OnDestroy {

	// INPUTS
	@Input('userID')
	userID = "";

	@Input('userName')
	userName = "";

	@Input('userDoc')
	userDoc = "";

	@Input('userCode')
	userCode = "";

	@Input('userCreditLimit')
	userCreditLimit = "";

	@Input('userExposure')
	userExposure = "";

	@Input('proposalStatus') proposalStatus: string = "";

	// 
	currentPage: number = 0;

	public orderby: string = "DataCriacao";
	public sort: string = "asc";
	public resultCount: number = 0;

	private totalExposition = 0;
	private groupType;
	private groupsSubscription: Subscription;

	private canEditSharedGroup;
	private groupLogs = [];
	private deleteList = [];

	private sharedEconomicGroup = [];
	private sharedEconomicGroupMembers = [];

	private individualEconomicGroups = [];
	private Relacao = false; //TEMP TO HIDE RELATION ITENS

	private permissions;

	constructor(private economicGroupService: EconomicGroupService, private router: Router, private dialogService: DialogService, private flashMessagesService: FlashMessagesService) { }

	paginar($event: any) {
		this.currentPage = $event;
		this.getGroupLog(this.currentPage);
	}

	ngOnInit() {
		this.permissions = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.groupsSubscription = this.economicGroupService.groupsChanged.subscribe(groupsChanged => {
			this.getUserGroups();
			this.getGroupLog(0);
		});
		this.getUserGroups();
		this.getGroupLog(0);
	}

	ngOnDestroy() {
		this.groupsSubscription.unsubscribe();
		this.sharedEconomicGroup = [];
		this.individualEconomicGroups = [];
	}

	getUserGroups() {
		this.economicGroupService.getEconomicGroups(this.userID).subscribe(result => {
			if (result.Result) {
				this.sharedEconomicGroup = result.Result.filter(group => group.ClassificacaoID == 1)
				this.sharedEconomicGroup.forEach(element => {
					this.totalExposition = this.totalExposition + +element.ExpTotalGrupo;
					console.log(this.totalExposition);
				});
				this.individualEconomicGroups = result.Result.filter(group => group.ClassificacaoID == 2);
				this.individualEconomicGroups.forEach(element => {
					this.totalExposition = this.totalExposition + +element.ExpTotalGrupo;
					console.log(this.totalExposition);
				});
			}
		}, error => {
			console.log(error);
		});
	}


	getGroupLog(page) {
		this.economicGroupService.getGroupLog(this.userID, this.orderby, this.sort, page).subscribe(result => {

			if (result.Result) {
				this.groupLogs = result.Result;
				this.resultCount = result.Count;
			}
		}, error => {
			console.log(error);
		});
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getGroupLog(this.currentPage);
	}

	reloadAccountClient() {
		this.router.navigateByUrl('/').then(
		() => {
			this.router.navigateByUrl('/conta-cliente/detalhe/' + this.userID);
		});
	}

	onCreateEconomicGroup(groupType) {
		this.groupType = groupType;
		this.dialogService.addDialog(EconomicGroupCreateComponent, {
			title: 'Adicionar Grupo Econômico',
			groupType: this.groupType,
			userID: this.userID,
			userName: this.userName,
			userDoc: this.userDoc,
			userCode: this.userCode,
			userExposure: this.userExposure,
			userCreditLimit: this.userCreditLimit
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.reloadAccountClient();
					//this.getUserGroups();
					//this.getGroupLog(0);
				}
				else {
					//Do nothing here for now
				}
			});
	}


}


// WEBPACK FOOTER //
// ./src/app/economic-group/component/economic-group/economic-group.component.ts